import { LanguageCode } from 'common/src/vtj/LanguageCode.enum'
import _ from 'lodash'
import { computed, observable } from 'mobx'
import { TodistuksetUi } from 'todistukset-ui/src/vtj/common-types'

export const init = ({
  browserUpdateRecommendations,
  flashPaymentCanceledNotification = false,
  lang = LanguageCode.FI,
  messageState = null,
  previousAddressDialogDismissed = false,
  queryParameters,
  sessionTimer = {},
  user,
}: TodistuksetUi.Store.InitCommon): TodistuksetUi.Store.Common => {
  const commonStoreData: Omit<TodistuksetUi.Store.Common, 'loggedInUser'> = {
    browserUpdateRecommendations,
    flashPaymentCanceledNotification,
    isElectronicMessagesEnabled: _.get(
      user,
      'suomifiViestit.electronicMessages.enabled',
      false
    ),
    lang,
    messageState,
    previousAddressDialogDismissed,
    queryParameters,
    sessionTimer,
    user,
  }

  const commonStore: TodistuksetUi.Store.Common = observable({
    ...commonStoreData,
    loggedInUser: computed(() => {
      const { user } = commonStoreData
      if (!user) {
        throw new Error(
          'loggedInUser must only be accessed from places where user exists'
        )
      }
      return user
    }),
  })

  return commonStore
}
